import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';
import { companiesService } from 'src/app/shared/vive-api/companies.service';

@Component({
  selector: 'app-add-client-registered-vendor-modal',
  templateUrl: './add-client-registered-vendor-modal.component.html',
  styleUrls: ['./add-client-registered-vendor-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddClientRegisteredVendorModalComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);
  constructor(
    private activeModal: NgbActiveModal,
    private AuthService: AuthService,
    private CompanyService: CompanyService,
    private ToastService: ToastService
  ) {}

  businessVerifiedOrNonVerified: 'Business Verified' | 'Non-Verified' =
    'Non-Verified';
  allowClientRegisteredVendors: boolean = false;
  allowExemptVendors: boolean = false;
  flagsLoaded: boolean = false;

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  closeModal(result?: any) {
    this.activeModal.close(result);
  }

  addClientRegisteredVendor() {
    this.closeModal('addClientRegisteredVendor');
  }

  addExemptVendor() {
    this.closeModal('addExemptVendor');
  }

  get promptText(): string {
    if (this.allowClientRegisteredVendors && this.allowExemptVendors) {
      return `Would you like to add a ${this.businessVerifiedOrNonVerified} Vendor or a Compliance Exempt Vendor?`;
    }
    if (this.allowClientRegisteredVendors) {
      return `Would you like to add a ${this.businessVerifiedOrNonVerified} Vendor?`;
    }
    if (this.allowExemptVendors) {
      return 'Would you like to add a Compliance Exempt Vendor?';
    }
    return 'This client is not configured to add Non-Verified, Business Verified, or Compliance Exempt vendors.';
  }

  ngOnInit(): void {
    from(
      companiesService.findOneById({
        pathParams: { companyId: this.AuthService.getUserCompanyId() }
      })
    ).subscribe({
      next: (Company) => {
        if (!Company) {
          throw this.ToastService.addErrorToast(
            'Error',
            'Cannot Add Vendor. No Company Record Found',
            { returnError: true }
          );
        }

        const {
          allowAutomatedBusinessVerificationClientRegisteredVendors,
          allowClientRegisteredVendors,
          allowExemptVendors
        } = Company;

        this.businessVerifiedOrNonVerified =
          allowAutomatedBusinessVerificationClientRegisteredVendors
            ? 'Business Verified'
            : 'Non-Verified';
        this.allowClientRegisteredVendors = !!allowClientRegisteredVendors;
        this.allowExemptVendors = !!allowExemptVendors;
        this.flagsLoaded = true;

        if (!this.allowClientRegisteredVendors && !this.allowExemptVendors) {
          this.ToastService.addErrorToast(
            'Error',
            'This client is not configured to add Non-Verified, Business Verified, or Compliance Exempt vendors.',
            { returnError: false }
          );
          this.close();
          return;
        }

        this._cdr.markForCheck();
      }
    });
  }
}
